import React from 'react';
export const getColorByEtapa = (etapaId) => {
    switch (etapaId) {
        case 1:
            return '#f59f1e';
        case 2:
            return '#28aaf0';
        case 3:
            return '#60c718';
        case 4:
            return '#158d8d';
        case 5:
            return '#ff511f';
        default:
            return '#d6dbed';
    }
};
export const EtapaDot = ({ title }) => {
    const etapaId = Number.parseInt(title.split(' ')[1]);
    return (React.createElement("span", { style: {
            display: 'inline-block',
            width: '10px',
            height: '10px',
            borderRadius: '50%',
            backgroundColor: getColorByEtapa(etapaId),
        } }));
};
//# sourceMappingURL=EtapaDot.js.map